if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this._navSetup = false;
        this._isNavClick = false;
      }

      hide() {
        if (this._isNavClick) {
          this._isNavClick = false;
          return;
        }
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupNavigation();
      }

      getAllMedia() {
        return Array.from(this.querySelectorAll('.product-media-modal__content .product-media-modal__item'));
      }

      showActiveMedia() {
        const targetId = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const allMedia = this.getAllMedia();

        allMedia.forEach((el) => {
          el.style.display = 'none';
          el.classList.remove('active');
        });

        let activeMedia = null;
        if (targetId) {
          activeMedia = allMedia.find((el) => el.dataset.mediaId === targetId);
        }
        if (!activeMedia && allMedia.length > 0) {
          activeMedia = allMedia[0];
        }
        if (!activeMedia) return;

        this.currentIndex = allMedia.indexOf(activeMedia);
        this._activateMedia(activeMedia);
        this._updateCounter();
      }

      _activateMedia(mediaEl) {
        const allMedia = this.getAllMedia();
        allMedia.forEach((el) => {
          el.style.display = 'none';
          el.classList.remove('active');
        });
        mediaEl.style.display = '';
        mediaEl.classList.add('active');

        const deferred = mediaEl.querySelector('deferred-media, product-model');
        if (deferred && typeof deferred.loadContent === 'function') {
          deferred.loadContent(false);
        }
      }

      showNext() {
        const allMedia = this.getAllMedia();
        if (allMedia.length <= 1) return;
        this.currentIndex = (this.currentIndex + 1) % allMedia.length;
        this._activateMedia(allMedia[this.currentIndex]);
        this._updateCounter();
      }

      showPrev() {
        const allMedia = this.getAllMedia();
        if (allMedia.length <= 1) return;
        this.currentIndex = (this.currentIndex - 1 + allMedia.length) % allMedia.length;
        this._activateMedia(allMedia[this.currentIndex]);
        this._updateCounter();
      }

      _updateCounter() {
        const counter = this.querySelector('.modal-nav-counter');
        if (counter) {
          counter.textContent = `${this.currentIndex + 1} / ${this.getAllMedia().length}`;
        }
      }

      setupNavigation() {
        if (this._navSetup) return;
        this._navSetup = true;

        const allMedia = this.getAllMedia();
        if (allMedia.length <= 1) return;

        this.addEventListener('keyup', (e) => {
          if (e.code === 'ArrowRight') this.showNext();
          if (e.code === 'ArrowLeft') this.showPrev();
        });

        // Prev/next buttons go INSIDE [role="dialog"], positioned left/right
        // Counter goes BELOW the content area, outside the image
        const dialog = this.querySelector('[role="dialog"]');
        if (!dialog) return;

        // Prev button
        const prevBtn = document.createElement('button');
        prevBtn.className = 'modal-nav-btn modal-nav-prev';
        prevBtn.type = 'button';
        prevBtn.setAttribute('aria-label', 'Предыдущее изображение');
        prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>`;

        // Next button
        const nextBtn = document.createElement('button');
        nextBtn.className = 'modal-nav-btn modal-nav-next';
        nextBtn.type = 'button';
        nextBtn.setAttribute('aria-label', 'Следующее изображение');
        nextBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>`;

        // Counter — separate element, placed after content
        const counter = document.createElement('div');
        counter.className = 'modal-nav-counter';
        counter.textContent = `${this.currentIndex + 1} / ${allMedia.length}`;

        // Stop propagation so clicks don't close modal
        [prevBtn, nextBtn, counter].forEach((el) => {
          el.addEventListener('pointerdown', () => { this._isNavClick = true; });
          el.addEventListener('pointerup', (e) => e.stopPropagation());
          el.addEventListener('click', (e) => e.stopPropagation());
        });

        prevBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this._isNavClick = true;
          this.showPrev();
        });

        nextBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this._isNavClick = true;
          this.showNext();
        });

        dialog.appendChild(prevBtn);
        dialog.appendChild(nextBtn);
        dialog.appendChild(counter);
      }
    }
  );
}